import {urlServices} from "./param-url.constants";

export const urlServiceHospitalResources = {

  medicines : {
    one: urlServices.urlServiceHospitalResources.concat('medicines/{medicineId}'),
    edit: urlServices.urlServiceHospitalResources.concat('medicines/{medicineId}'),
    list: urlServices.urlServiceHospitalResources.concat('medicines/branchOffice/{branchOfficeId}'),
    new: urlServices.urlServiceHospitalResources.concat('medicines'),
    delete: urlServices.urlServiceHospitalResources.concat('medicines/{medicineId}'),
    newFormula: urlServices.urlServiceHospitalResources.concat('medicines/{medicineId}/formula'),
    deleteFormula: urlServices.urlServiceHospitalResources.concat('medicines/formula/{medicineFormulaId}'),
  },

  catalogManagement : {
    //api/hospitals-resources/catalogs-management/branch-offices/{branchId}/keys/{cveCatalog}
    catalog: urlServices.urlServiceHospitalResources.concat('catalogs-management/branch-offices/{branchId}/keys/{cveCatalog}'),
  },
  
  vitalSigns : {
    vital:urlServices.urlServiceHospitalResources.concat('vital-signs/units/specialities/${unitId}/${specialityId}')
  },
  
  auxiliary : {
    list: urlServices.urlServiceHospitalResources + 'auxiliaries',
    new: urlServices.urlServiceHospitalResources + 'auxiliaries',
    packageItems: urlServices.urlServiceHospitalResources + 'auxiliaries/catalog-package-items',
    one: urlServices.urlServiceHospitalResources + 'auxiliaries/',
    save: urlServices.urlServiceHospitalResources + 'auxiliaries/',
    delete: urlServices.urlServiceHospitalResources + 'auxiliaries/{auxiliaryId}',
    typeCatalog: urlServices.urlServiceHospitalResources + 'auxiliaries/catalog-types',
    search: urlServices.urlServiceHospitalResources + 'auxiliaries/search'
  },
  rooms: {
    list: urlServices.urlServiceHospitalResources + 'rooms/branch-offices/',
    filter: urlServices.urlServiceHospitalResources + 'rooms/branch-offices/{branchOfficeId}/filter',
    one: urlServices.urlServiceHospitalResources + 'rooms/{roomId}',
    upsert: urlServices.urlServiceHospitalResources + 'rooms',
    delete: urlServices.urlServiceHospitalResources + 'rooms/{roomId}'
  },
  catalogs: {
    specialitiesByModule: urlServices.urlServiceHospitalResources + 'catalogs/modules/{moduleId}/specialities',
    bedTypes: urlServices.urlServiceHospitalResources + 'catalogs/bed-types',
    biologicalSexes: urlServices.urlServiceHospitalResources + 'catalogs/biological-sexes',
    //biologicalSexes: urlServices.urlServicePatients + 'catalogs/biological-sexes',
    clueAges: urlServices.urlServiceHospitalResources + 'catalogs/clue-ages',
    //api/hospitals-resources/catalogs/bed-states
    bedStates: urlServices.urlServiceHospitalResources + 'catalogs/bed-states',
    //api/hospitals-resources/catalogs/sexes
    sex: urlServices.urlServiceHospitalResources + 'catalogs/sexes',
    sexByCategory: urlServices.urlServiceHospitalResources + 'catalogs/sexes/category',
    morphologies: urlServices.urlServiceHospitalResources + 'catalogs/morphologies'
  },
  beds: {
    list: urlServices.urlServiceHospitalResources + 'rooms/{roomId}/beds',
    one: urlServices.urlServiceHospitalResources + 'beds/{bedId}',
    upsert: urlServices.urlServiceHospitalResources + 'beds'
  }
};

export const urlServiceHospitalResource = {
  ///vital-signs/find-by-id/{vitalSignId}
  catalogVitalSignById: urlServices.urlServiceHospitalResources + 'vital-signs/find-by-id/{vitalSignId}',
  ///vital-signs/{branchOfficeId}
  catalogVitalSigns: urlServices.urlServiceHospitalResources + 'vital-signs/{branchOfficeId}',
  ///vital-signs/find-by-filters
  catalogVitalSignsByFilters: urlServices.urlServiceHospitalResources + 'vital-signs/find-by-filters',
  ///vital-signs/save-order-vital-signs
  saveOrderVitalSign: urlServices.urlServiceHospitalResources + 'vital-signs/save-order-vital-signs',
  ///vital-signs/save-vital-signs
  saveVitalSign: urlServices.urlServiceHospitalResources + 'vital-signs/save-vital-signs',
  ///vital-signs/update-vital-signs
  updateVitalSign: urlServices.urlServiceHospitalResources + 'vital-signs/update-vital-signs',
  ///vital-signs/delete-vital-signs
  deleteVitalSign: urlServices.urlServiceHospitalResources + 'vital-signs/delete-vital-signs/{vitalSignId}',
  ///vital-signs/catalogs/option-sex
  catalogUnits: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/units/{branchOfficeId}',
  ///vital-signs/catalogs/option-sex
  catalogOptionSex: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/option-sex',
  ///vital-signs/catalogs/unities-measurement
  catalogUnitiesMeasurement: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/unities-measurement',
  ///vital-signs/catalogs/vital-signs-type
  catalogVitalSignType: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/vital-signs-type',
  ///vital-signs/catalogs/formulas-type
  catalogFormulasType: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/formulas-type',
  ///catalogs/clue-ages
  catalogClueAge: urlServices.urlServiceHospitalResources + 'vital-signs/catalogs/clue-ages',
  
  catalogDiet: urlServices.urlServiceHospitalResources + 'diets',
};